import React, { useContext, useState } from 'react';
import { useAuthentication } from '@zen/identity-lib';
import { OAuthApiClient } from '../../clients/OAuthApiClient';

interface Props {
  apiBaseUrl: string;
  bssApiBaseUrl: string;
}

interface ApiContextProps {
  publicApiClient: OAuthApiClient,
  bssApiClient: OAuthApiClient
}

const ApiContext = React.createContext<ApiContextProps | null>(null);

const Api: React.FunctionComponent<Props> = (props) => {
  const { apiBaseUrl, bssApiBaseUrl, children } = props;
  const authentication = useAuthentication();
  const [publicApiClient] = useState(new OAuthApiClient(apiBaseUrl, authentication));
  const [bssApiClient] = useState(new OAuthApiClient(bssApiBaseUrl, authentication));

  return <ApiContext.Provider value={{publicApiClient, bssApiClient}}>{children}</ApiContext.Provider>;
};

export default ApiContext;

const useApi = () => useContext(ApiContext);

export { Api, useApi };
